const hostDomain = window.location.origin;
const pathName = window.location.pathname;
const isDev = pathName?.startsWith('/rlinkdev_') || pathName?.startsWith('/meetndev_');
export const isRlink = pathName?.startsWith('/rlink_') || pathName?.startsWith('/rlinkdev_');

export const meetnURL = isDev ? 'dev-api.meetn.com' : 'api.meetn.com';
export const rlinkURL = isDev ? 'dev-api.r-link.com' : 'live-api.r-link.com';
export const socketURL = isRlink ? `wss://${rlinkURL}` : `wss://${meetnURL}`;
